import React from 'react';

const Blogrs = () => {
    return (
        <div className='text-xl text-black font-bold'>
            comming soon
        </div>
    );
};

export default Blogrs;